
export default class GoogleMap {

    /**
     *
     * @param {HTMLElement} containerEl
     * @param {google.maps.MapOptions} mapOptions
     */
    constructor(containerEl, mapOptions = {}) {
        if (typeof window.google === "object" && typeof window.google.maps === "object") {
			/**
			 * @type {HTMLElement}
			 */
            this.containerEl = containerEl;
			/**
			 * @type {google.maps.Marker[]}
			 */
            this.markers = [];
			/**
			 * @type {HTMLElement[]}
			 */
            this.$markers = [];
            /**
             * @type google.maps.Map
             */
            this.map = this.renderMap(containerEl, mapOptions);
			this.centerMap();
        }
        else {
            console.error("Google Map API key is not present!");
        }
    }

    /**
     *
     * @param {HTMLElement} $el
     * @param {google.maps.MapOptions} mapOptions
     * @returns {google.maps.Map|*}
     */
    renderMap($el, mapOptions = {}) {
        /**
         *
         * @type {NodeListOf<HTMLElement>}
         */
        let $markers = $el.querySelectorAll('.marker');

        /**
         *
         * @type {google.maps.MapOptions}
         */
        let args = {
            zoom: 16,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scrollwheel: false
        };

        args = {...args, ...mapOptions};

        // create map
        let map = new google.maps.Map($el, args);

        // add markers
        $markers.forEach(item => {
            this.addMarker(item, map);
        });

        return map;
    }

    /**
     *
     * @param {HTMLElement} $marker
     * @param {google.maps.Map} map
     * @return {google.maps.Marker}
     */
    addMarker($marker, map) {

        let lat = parseFloat($marker.getAttribute('data-lat'));
        let lng = parseFloat($marker.getAttribute('data-lng'));

        let latlng = new google.maps.LatLng(lat, lng);
        let url = $marker.getAttribute("data-url");

        /**
         *
         * @type {google.maps.Marker}
         */
        let marker = new google.maps.Marker({
            position: latlng
        });

        let iconConfig = this.getMarkerIconConfig($marker);
        if (iconConfig) {
            marker.setIcon(iconConfig);
        }

        // add to array
        marker.setMap(map);
        this.markers.push(marker);
        this.$markers.push($marker);

        // if marker contains HTML, add it to an infoWindow
        let $markerHtml = $marker.innerHTML;
        if ($markerHtml !== "") {
            // create info window
            let infowindow = new google.maps.InfoWindow({
                content: $marker.innerHTML
            });

            // show info window when marker is clicked
            google.maps.event.addListener(marker, 'click', function () {

                infowindow.open(map, marker);

            });
        }

        if (url) {
            marker.addListener("click", () => {
                window.open(url);
            });
        }

        return marker;

    }

    /**
     *
     * @param {google.maps.Marker|null} marker
	 * @param {number} zoom
     */
    centerMap(marker= null, zoom = 8) {

        // vars
        let bounds = new google.maps.LatLngBounds();

		if (marker === null) {
			// loop through all markers and create bounds
			this.markers.forEach(marker => {

				let latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

				bounds.extend(latlng);

			});
		}
		else {
			bounds.extend(marker.getPosition());
		}


        // only 1 marker?
        if (this.markers.length === 1 || marker !== null) {
            // set center of map
            this.map.setCenter(bounds.getCenter());
            this.map.setZoom(zoom);
        }
        else if (this.markers.length > 0) {
            // fit to bounds
            this.map.fitBounds(bounds);
        }

    }

    /**
     *
     * @param {HTMLElement} $marker
     * @returns {null|*}
     */
    getMarkerIconConfig($marker) {
        return null;
    }

}
